module.exports = __webpack_public_path__ + "img/nu.d27f33e2.svg";